"use client";

import { useInfront } from "@/context/infront-context";
import {
  createInstrumentSlug,
  DEFAULT_CONTENT,
} from "@/services/infront/utils";
import { useRouter } from "next/navigation";
import { useEffect, useRef } from "react";

export const INDICIES = [
  { feed: 17921, ticker: "OMXS30" },
  { feed: 2087, ticker: "NDX" },
  { feed: 6150, ticker: "N225" },
  { feed: 2198, ticker: "HSI" },
  { feed: 17921, ticker: "OMXSPI" },
  { feed: 18177, ticker: "OBX" },
  { feed: 17665, ticker: "OMXC25" },
  { feed: 100, ticker: "OMXH25" },
  { feed: 2302, ticker: "BDE40P" },
];

const ID = "simple-instrument-list";

type SimpleInstrumentListProps = {
  title: string;
};

const SimpleInstrumentList = (props: SimpleInstrumentListProps) => {
  const router = useRouter();
  const { isReady, load } = useInfront();

  const widgetRef = useRef<any>(null);

  useEffect(() => {
    let active = true;

    load?.(["core"]).then(() => {
      if (!isReady || !active) return;

      widgetRef.current?.destroy();
      widgetRef.current = null;

      const widgetOptions = new window.Infront.QuoteListWidgetOptions();

      widgetOptions.onInstrumentSelected = (instrument: {
        feed: number;
        ticker: string;
      }) => {
        router.push(createInstrumentSlug(instrument.feed, instrument.ticker));
      };

      widgetOptions.widgetTitle = props.title;
      widgetOptions.defaultContent = DEFAULT_CONTENT;
      widgetOptions.enableChangeStatusColors = true;

      widgetOptions.columns = [
        {
          name: "TICKER",
          flag: true,
        },
        "PCT_CHANGE",
      ];

      widgetOptions.instruments = INDICIES;

      widgetRef.current = window.infront.quoteList(`#${ID}`, widgetOptions);
    });

    return () => {
      active = false;
      widgetRef.current?.destroy();
      widgetRef.current = null;
    };
  }, [isReady, router, props.title]);

  return <div id={ID} className="card" />;
};

export default SimpleInstrumentList;
